// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__yZEQv","brand":"Footer_brand__PQNV-","links":"Footer_links__YUZUc"};